const stockFormatter = new Intl.NumberFormat("en-US");

/**
 * A stock count as shown on the product form: the Stock total and each
 * vendor offering's stock, formatted alike ("1,200"). An unknown count
 * (null, or a row that omits it) is an em-dash.
 */
export const formatStock = (quantity: number | null | undefined): string =>
    quantity == null ? "—" : stockFormatter.format(quantity);
